module.exports = "/assets/data/f85f1630d64a15855afb2eb554be64e0-BS1.data.json";